import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
/**
 * This component will trigger the passed `onInView` prop when the children are in view.
 *
 * This is basically a div wrapper around `useInView`.
 */
export const ChildrenInView = ({ children, style, onInView, options, }) => {
    // "in-view" hook that checks whether the box around replies has been viewed long enough
    const { inView, ref } = useInView(options);
    // If the user scrolls far enough to see the loader link, start loading more.
    useEffect(() => {
        if (inView)
            onInView();
    }, [inView, onInView]);
    return (_jsx("div", Object.assign({ style: style, ref: ref }, { children: children })));
};
